import type { ApprovalChain } from '../approval-chain.model';

export const BOND_CANCELLATION_CHAIN: ApprovalChain = {
  id: 'bond-cancellation',
  label: 'Bond Cancellation',
  applicationTypes: ['BOND_CANCELLATION'],
  steps: [
    { role: 'SECOND_BANK_USER', action: 'Recommend', from: ['SUBMITTED', 'RESUBMITTED'], to: 'SECOND_BANK_USER_APPROVED' },
    { role: 'MEMBER_ADMIN', action: 'Recommend', from: ['SECOND_BANK_USER_APPROVED'], to: 'LAW_FIRM_APPROVED' },
    { role: 'CONVEYANCER', action: 'Recommend', from: ['LAW_FIRM_APPROVED'], to: 'CONVEYANCER_APPROVED' },
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'PENDING_REVIEW', 'RESUBMITTED', 'CONVEYANCER_APPROVED'], to: 'FINANCE_APPROVED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
